import Cookies from "js-cookie";
var eventName = "locale:changed";
var func;
var lang = "en";
var COOKIE_NAME = "SESSvl";
function getCookie() {
    return Cookies.get(COOKIE_NAME);
}
function setCookie(language) {
    Cookies.set(COOKIE_NAME, language, {
        expires: 365,
        path: "/",
        secure: false,
        domain: ".matterport.com",
        sameSite: "lax",
    });
}
function broadcast(language) {
    lang = language;
    var event = new CustomEvent("locale:changed", {
        detail: {
            language: language,
        },
    });
    document.dispatchEvent(event);
}
function listen(callback) {
    func = callback;
    document.addEventListener(eventName, callback);
}
function remove() {
    document.removeEventListener(eventName, func);
}
export function getLang() {
    return lang;
}
export default {
    broadcast: broadcast,
    getCookie: getCookie,
    listen: listen,
    remove: remove,
    setCookie: setCookie,
};
